<template>
  <div>
    
    <el-form ref="form" label-position="left" label-width="80px">
      <el-form-item label="新 基 建" label-width="150px">
      </el-form-item>
      <el-form-item label="智慧应用">
        <el-checkbox-group v-model="checkedIndustrycategories1" @change="handleIndustrycategoryChange1">
          <el-checkbox v-for="category,index in industrycategories.newConstruction.wisdom.list" :label="category" :key="category"
            :ref="'wis'+index" :id="'wis'+index" @change="selectOne('wis'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="数据智能">
        <el-checkbox-group v-model="checkedIndustrycategories2" @change="handleIndustrycategoryChange2">
          <el-checkbox v-for="category,index in industrycategories.newConstruction.data.list" :label="category" :key="category"
            :ref="'nc'+index" :id="'nc'+index" @change="selectOne('nc'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="生态系统">
        <el-checkbox-group v-model="checkedIndustrycategories3" @change="handleIndustrycategoryChange3">
          <el-checkbox v-for="category,index in industrycategories.newConstruction.ecosystom.list" :label="category"
            :key="category" :ref="'ey'+index" :id="'ey'+index" @change="selectOne('ey'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="数字安全">
        <el-checkbox-group v-model="checkedIndustrycategories4" @change="handleIndustrycategoryChange4">
          <el-checkbox v-for="category,index in industrycategories.newConstruction.security.list" :label="category"
            :key="category" :ref="'st'+index" :id="'st'+index" @change="selectOne('st'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="新型网络">
        <el-checkbox-group v-model="checkedIndustrycategoriesNewnet" @change="handleNewnet">
          <el-checkbox v-for="category,index in industrycategories.newConstruction.newnet.list" :label="category" :key="category"
            :ref="'nt'+index" :id="'nt'+index" @change="selectOne('nt'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="智慧专区">
        <el-checkbox-group v-model="checkedIndustrycategories5" @change="handleIndustrycategoryChange5">
          <el-checkbox v-for="category,index in industrycategories.cloudata.list" :label="category" :key="category"
            :ref="'cd'+index" :id="'cd'+index" @change="selectOne('cd'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="数字上云">
        <el-checkbox-group v-model="checkedIndustrycategories7" @change="handleIndustrycategoryChange7">
          <el-checkbox v-for="category,index in industrycategories.digitizationCloud.list" :label="category" :key="category"
            :ref="'dg'+index" :id="'dg'+index" @change="selectOne('dg'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="金融服务">
        <el-checkbox-group v-model="checkedIndustrycategories6" @change="handleIndustrycategoryChange6">
          <el-checkbox v-for="category,index in industrycategories.service.list" :label="category" :key="category"
            :ref="'sv'+index" :id="'sv'+index" @change="selectOne('sv'+index)">{{category}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
  import {
    Checkbox,
    CheckboxGroup,
    Form,
    FormItem,
  } from 'element-ui';

  export default {
    name: 'NewConstructor',
    components: {
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
    },
    props: {
      selectedOptions: {
        type: String,
      },
    },
    watch: {
      selectedOptions(value) {
        console.log("call selectedOptions.... ");
        console.log(value);
        this.handleSelectedOptionsProps(value);
      },
    },
    data() {
      return {
        lastRef: "",
        industrycategories: {
          newConstruction: {
            name: '新基建',
            wisdom: {
              name: '智慧应用',
              list: [
                '智慧政务应用',
                '智慧城市应用',
                '智慧民生应用',
                '智慧产业应用',
                '传统基础设施赋能',
                '中小企业赋能',
              ],
            },
            data: {
              name: '数据智能',
              list: [
                '数据中心',
                '云边端',
                '大数据平台',
                '人工智能',
                '区块链服务平台',
                '数据交易',
              ],
            },
            ecosystom: {
              name: '生态系统',
              list: [
                '产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台',
              ],
            },
            security: {
              name: '可信安全',
              list: [
                '基础安全能力', '行业应用安全', '新型安全服务平台',
              ],
            },
            newnet: {
              name: '新型网络',
              list: [
                '5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网',
              ],
            },
          },
          cloudata: {
            name: '智慧专区',
            list: ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务']
          },
          digitizationCloud: {
            name: '数字上云',
            list: ['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商']
          },
          service: {
            name: '金融服务',
            list: ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
          },
        },
        checkAll: false,
        checkAll1: false,
        checkAll2: false,
        checkAll3: false,
        checkAll4: false,
        checkAllNewnet: false,
        checkedIndustrycategories1: [],
        checkedIndustrycategories2: [],
        checkedIndustrycategories3: [],
        checkedIndustrycategories4: [],
        checkedIndustrycategories5: [],
        checkedIndustrycategories6: [],
        checkedIndustrycategoriesNewnet: [],
        checkedIndustrycategories7: [],
      };
    },
    mounted() {
      // this.emitData();
      if (this.selectedOptions.length > 0) {
        this.handleSelectedOptionsProps(this.selectedOptions);
      }
    },
    methods: {
      selectOne(ref) {
        console.log("ref", ref)

        this.checkedIndustrycategories1.splice(0, this.checkedIndustrycategories1.length)
        this.checkedIndustrycategories2.splice(0, this.checkedIndustrycategories2.length)
        this.checkedIndustrycategories3.splice(0, this.checkedIndustrycategories3.length)
        this.checkedIndustrycategories4.splice(0, this.checkedIndustrycategories4.length)
        this.checkedIndustrycategoriesNewnet.splice(0, this.checkedIndustrycategoriesNewnet.length)
        this.checkedIndustrycategories5.splice(0, this.checkedIndustrycategories5.length)
        this.checkedIndustrycategories6.splice(0, this.checkedIndustrycategories6.length)
        this.checkedIndustrycategories7.splice(0, this.checkedIndustrycategories7.length)

        var cur = this.$refs[ref]

        var curname = cur[0].label
        if (ref.indexOf("wis") > -1) {
          this.checkedIndustrycategories1.push(curname)
        } else if (ref.indexOf("nc") > -1) {
          this.checkedIndustrycategories2.push(curname)
        } else if (ref.indexOf("ey") > -1) {
          this.checkedIndustrycategories3.push(curname)
        } else if (ref.indexOf("st") > -1) {
          this.checkedIndustrycategories4.push(curname)
        } else if (ref.indexOf("nt") > -1) {
          this.checkedIndustrycategoriesNewnet.push(curname)
        } else if (ref.indexOf("cd") > -1) {
          this.checkedIndustrycategories5.push(curname)
          console.log(this.checkedIndustrycategories5)
        } else if (ref.indexOf("sv") > -1) {
          this.checkedIndustrycategories6.push(curname)
          console.log(this.checkedIndustrycategories6)
        } else if (ref.indexOf("dg") > -1) {
          this.checkedIndustrycategories7.push(curname)
          console.log(this.checkedIndustrycategories6)
        }

        this.lastRef = ref
      },
      handleSelectedOptionsProps(v) {
        if (v) {
          console.log("handleSelectedOptionsProps---v=(" + v + ")")
          const options = v.split(';');
          this.checkedIndustrycategories1 = this.industrycategories.newConstruction.wisdom.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategories2 = this.industrycategories.newConstruction.data.list.filter((item) => options.includes(
            item)) || [];
          this.checkedIndustrycategories3 = this.industrycategories.newConstruction.ecosystom.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategories4 = this.industrycategories.newConstruction.security.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategoriesNewnet = this.industrycategories.newConstruction.newnet.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategories5 = this.industrycategories.cloudata.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategories6 = this.industrycategories.service.list.filter((item) =>
            options.includes(item)) || [];
          this.checkedIndustrycategories7 = this.industrycategories.digitizationCloud.list.filter((item) =>
            options.includes(item)) || [];
          this.checkAll1 = this.checkedIndustrycategories1.length === this.industrycategories.newConstruction.wisdom.list
            .length;
          this.checkAll2 = this.checkedIndustrycategories2.length === this.industrycategories.newConstruction.data.list
            .length;
          this.checkAll3 = this.checkedIndustrycategories3.length === this.industrycategories.newConstruction.ecosystom
            .list.length;
          this.checkAll4 = this.checkedIndustrycategories4.length === this.industrycategories.newConstruction.security.list
            .length;
          this.checkAllNewnet = this.checkedIndustrycategoriesNewnet.length === this.industrycategories.newConstruction
            .newnet.list.length;

          this.handleCheckAll();
        }
      },
      handleCheckAllChange(val) {
        this.handleCheckAllChange1(val);
        this.handleCheckAllChange2(val);
        this.handleCheckAllChange3(val);
        this.handleCheckAllChange4(val);
        this.handleCheckAllChangeNewnet(val);
        this.checkAll1 = val;
        this.checkAll2 = val;
        this.checkAll3 = val;
        this.checkAll4 = val;
        this.checkAllNewnet = val;
      },
      handleCheckAll(notemit) {
        const checked = this.checkedIndustrycategories1.length +
          this.checkedIndustrycategories2.length +
          this.checkedIndustrycategories3.length +
          this.checkedIndustrycategories4.length +
          this.checkedIndustrycategoriesNewnet.length;
        const total = this.industrycategories.newConstruction.wisdom.list.length +
          this.industrycategories.newConstruction.wisdom.list.length +
          this.industrycategories.newConstruction.ecosystom.list.length +
          this.industrycategories.newConstruction.security.list.length +
          this.industrycategories.newConstruction.newnet.list.length;
        this.checkAll = checked === total;
        this.emitData();
      },
      handleCheckAllChange1(val) {
        console.log("val", val)
        this.checkedIndustrycategories1 = val ? this.industrycategories.newConstruction.wisdom.list : [];
        this.handleCheckAll();
      },
      handleCheckAllChange2(val) {
        this.checkedIndustrycategories2 = val ? this.industrycategories.newConstruction.data.list : [];
        this.handleCheckAll();
      },
      handleCheckAllChange3(val) {
        this.checkedIndustrycategories3 = val ? this.industrycategories.newConstruction.ecosystom.list : [];
        this.handleCheckAll();
      },
      handleCheckAllChange4(val) {
        this.checkedIndustrycategories4 = val ? this.industrycategories.newConstruction.security.list : [];
        this.handleCheckAll();
      },
      handleCheckAllChangeNewnet(val) {
        this.checkedIndustrycategoriesNewnet = val ? this.industrycategories.newConstruction.newnet.list : [];
        this.handleCheckAll();
      },
      handleIndustrycategoryChange1(value) {
        this.checkAll1 = value.length === this.industrycategories.newConstruction.wisdom.list.length;
        this.handleCheckAll();
      },
      handleIndustrycategoryChange2(value) {
        this.checkAll2 = value.length === this.industrycategories.newConstruction.data.list.length;
        this.handleCheckAll();
      },
      handleIndustrycategoryChange3(value) {
        this.checkAll3 = value.length === this.industrycategories.newConstruction.ecosystom.list.length;
        this.handleCheckAll();
      },
      handleIndustrycategoryChange4(value) {
        this.checkAll4 = value.length === this.industrycategories.newConstruction.security.list.length;
        this.handleCheckAll();
      },
      handleIndustrycategoryChange5(value) {
        this.handleCheckAll();
      },
      handleIndustrycategoryChange6(value) {
        this.handleCheckAll();
      },
      handleIndustrycategoryChange7(value) {
        this.handleCheckAll();
      },
      handleNewnet(value) {
        this.checkAllNewnet = value.length === this.industrycategories.newConstruction.newnet.list.length;
        this.handleCheckAll();
      },
      getCheckedCategories() {
        return [...this.checkedIndustrycategories1, ...this.checkedIndustrycategories2, ...this.checkedIndustrycategories3,
          ...this.checkedIndustrycategories4, ...this.checkedIndustrycategoriesNewnet, ...this.checkedIndustrycategories5,
          ...this.checkedIndustrycategories6, this.checkedIndustrycategories7
        ];
      },
      emitData() {
        this.$emit('dataChange', this.getCheckedCategories().join(';'));
      },
    },
  };
</script>

<style scoped>
  @import url(../main.css);
</style>
